module.exports = __webpack_public_path__ + "static/media/running_man_contact.e1ba2192.svg";